export enum EGeneralPlanList {
  Free = 'free',
  PayAsYouGo = 'pay-as-you-go',
  Deal = 'deal',
}

export enum EPlan {
  Enterprise = 'enterprise',
}
